import script from "./CoursesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CoursesPage.vue?vue&type=script&setup=true&lang=js"

import "./CoursesPage.vue?vue&type=style&index=0&id=8586bc80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8586bc80"]])

export default __exports__